import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/main.css';
import Element from 'element-ui';
// import "./assets/css/form.css";
import store from './store/store.js';
import router from './router';
import axios from 'axios';
import moment from "moment-timezone";
import C from '@/const';
import * as VueGoogleMaps from 'vue2-google-maps';
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';
import VuePictureSwipe from 'vue-picture-swipe';
Vue.component('vue-picture-swipe', VuePictureSwipe);

import firebase from '@/firebase/firebaseInit';
const auth = firebase.auth;
const db = firebase.db;

Vue.config.productionTip = false;
Vue.use(BootstrapVue, axios);
Vue.prototype.$moment = moment;
Vue.prototype.$C = C;

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB516qi_hSRP4x1FLnLshdGZ2l1weqKF2Y',
    libraries: 'places',
  },
});

Vue.use(Element);

auth.onAuthStateChanged(() => {
  db;
  // if (!app) {
  new Vue({
    store,
    router,
    render: (h) => h(App),
  }).$mount('#app');
  // }
});
